import { Component } from '@angular/core';
import { UserModel } from './services/user-model';
import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  title = 'Solunes Organización';
  constructor(
    private userModel: UserModel,
    private metaTitle: Title,
    private meta: Meta
  ) {
    this.initializeApp();
  }

  initializeApp() {
    // Meta Title
    this.metaTitle.setTitle(`${this.userModel.getTitle()} | ${this.title}`);
    this.meta.addTags([
      // Description
      { name: 'description', content: 'This is an article about Angular Meta service' },
      // Keywords
      { name: 'keywords', content: 'angular, javascript, typescript, meta, seo' }
    ]);
  }

}
